module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s04-2_s-7cfd4b06175801691f3d21bd584e5bbb.png";